// @flow
import type { UserProgressReducerState } from '../../reducers/userProgressReducer';
import type { FinishedChapter } from '../type/FinishedChapter';

export var applyFinishedChapterIdsSelector = function(userProgress: UserProgressReducerState): Array<number> {
    return userProgress.finishedChapters.map((finishedChapter: FinishedChapter) => finishedChapter.id);
};
